<template>
  <vue-modal :key="refreshModal" ref="value-player-icons-list" name="value-player-icons-list" :adaptive="true" :width="500" :height="'auto'" :scrollable="true" @before-open="onBeforeOpen" >
    <div class="d-flex flex-column h-100">
      <div class="modal-header">
        <h5 class="modal-title">Value Player Icons</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <!-- SCROLLABLE BODY -->
      <div class="modal-body flex-grow-1 overflow-auto">
        <div class="container">
          <div class="row w-100 justify-content-center text-center">
            <div class="col-4 d-flex flex-column align-items-center mb-3" 
              v-for="(valuePlayerIconOption, idxIcon) in valuePlayerIconOptions" :key="idxIcon">
              <!-- Icon + radio -->
              <div class="d-flex align-items-center justify-content-center mb-1">
                <input type="radio" class="mr-2" :id="`playerIcon-${idxIcon}`" name="playerIcon" v-model="selectedIconObj" :value="valuePlayerIconOption" />
                <img :src="valuePlayerIconOption.imagePath" width="50" height="50" class="d-block" />
              </div>
              <!-- Icon label -->
              <div class="small font-weight-bold">{{ valuePlayerIconOption.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- FIXED FOOTER BUTTONS -->
      <div class="modal-footer d-flex justify-content-end">
        <button type="button" class="btn btn-primary ml-2" :disabled="!selectedIconObj" @click="confirmIcon">
          <span>Select Icon</span>
          <span v-show="getModalLoading()" class="spinner-border spinner-border-sm"></span>
        </button>
        <button type="button" class="btn btn-primary ml-3" @click="closeModal">
          Close
        </button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import ContentMixins from "../mixins/ContentMixins.vue";
import ViewMixins from "../mixins/ViewMixins.vue";

export default {
  name: "ImportValuePlayerIcon",
  components: {},
  mixins: [ContentMixins, ViewMixins],

  methods: {
    onBeforeOpen() {
        // Clear the previously selected icon each time modal opens
        this.selectedIconObj = null;
    },
    closeModal() {
      if (this.$refs['value-player-icons-list'] != null) {
        this.$refs['value-player-icons-list'].visible = false;
      }
      this.refreshModal = !this.refreshModal;
    },
    confirmIcon() {
        if (!this.selectedIconObj) return;
        this.$emit('icon-selected', {
            rowIndex: this.rowIndex,
            icon: this.selectedIconObj
        });
        this.closeModal();
    }
  },
  props: {
    rowIndex: {
      type: Number,
      required: false,
      default: null
    },
    valuePlayerIconOptions: {
        type: Array,
        required: true,
        default: () => []
    },
  },
  data() {
    return {
        selectedIconObj: null, 
        refreshModal: true
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>
